<template>
  <v-tooltip
    :disabled="disabledTooltip"
    bottom
  >
    <template v-slot:activator="{ on }">
      <div v-on="on" class="percent-bar__container bg-gray">
        <div class="percent-bar__automatica primary" :style="`width: ${percentAutomatico}`"></div>
        <div class="percent-bar__manual accent" :style="`width: ${percentManual}`"></div>
      </div>
    </template>

    <div class='px-3 py-1 ma-0'>
      <div>
        <div class="percent-bar__bullet primary mr-2"></div>
        <span>{{ textAutomatica }}</span>
      </div>
      <div>
        <div class="percent-bar__bullet accent mr-2"></div>
        <span>{{ textManual }}</span>
      </div>
      <div>
        <div class="percent-bar__bullet bg-gray mr-2"></div>
        <span>{{ textRestante }}</span>
      </div>
    </div>
  </v-tooltip>
</template>

<style>
.percent-bar__container {
  display: flex;
  height: 8px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.percent-bar__automatica {
  height: 100%;
}

.percent-bar__manual {
  height: 100%;
  border-radius: 0 4px 4px 0;
}

.percent-bar__bullet {
  display: inline-block;
  height: 8px;
  width: 8px;
  border-radius: 999px;
}

.bg-gray {
  background-color: #A8A8A8;
}

</style>

<script>

const formatter = new Intl.NumberFormat('en', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 })

export default {
  props: {
    total: Number,
    automatica: Number,
    manual: Number,
    textAutomatica: String,
    textManual: String,
    textRestante: String
  },
  computed: {
    disabledTooltip () {
      return !this.textAutomatica || !this.textManual || !this.textRestante
    },
    percentAutomatico () {
      return formatter.format(this.automatica / 100)
    },
    percentManual () {
      return formatter.format(this.manual / 100)
    }
  }
}
</script>
